import React from 'react'

export const BibReferencesContext = React.createContext('bibReferences')
